export const STOPPED_PAYMENTS_REPORT_UPDATED = "STOPPED_PAYMENTS_REPORT_UPDATED";
export const STOPPED_PAYMENTS_REPORT_COMPLETED = "STOPPED_PAYMENTS_REPORT_COMPLETED";
